import loadable from "@loadable/component";
export const ResetPasswordPage = loadable(() => import("./ResetPassword"));
